import React from 'react';
import './styles.css';
import { Col, Button } from 'antd';
import {
  CommentsList,
  CommentForm,
  RBAC
} from '@BUP/components';
import { useAuth } from '@BUP/hooks';

const ChatBox = ({
  messageCreator,
  isCaseOpen,
  onOpenMainMessage,
  messages,
  isLoading,
  onSendMessage,
  chatContainerRef,
  fatherMessage
}) => {
  const { user } = useAuth();

  return (
    <Col
      className="chatbox-container"
      xs={24}
      lg={20}
      xxl={18}
    >
      <div
        className={`title-wrapper ${!isCaseOpen && "title-dark"}`}
      >
        {messageCreator}
      </div>
      <div
        className={`chat-content ${!isCaseOpen && "content-dark"}`}
      >
        <CommentsList
          comments={messages}
          user={user}
          isLoading={isLoading}
          chatContainerRef={chatContainerRef}
          isCaseOpen={isCaseOpen}
        />
        {
          isCaseOpen ?
            (
              <CommentForm
                onSendMessage={onSendMessage}
              />
            ) :
            (
              <RBAC name="openOrCloseMessageButton">
                <div className="active-case-wrapper">
                  <Button
                    type="primary"
                    shape="round"
                    size="large"
                    ghost={true}
                    style={{ fontWeight: 'bold' }}
                    onClick={() => onOpenMainMessage(fatherMessage.id)}
                  >
                    Abrir Caso
                  </Button>
                </div>
              </RBAC>
            )
        }
      </div>
    </Col>
  )
}

export default ChatBox;